import { render, staticRenderFns } from "./BankCard.vue?vue&type=template&id=c45e05ba&scoped=true&"
import script from "./BankCard.vue?vue&type=script&lang=js&"
export * from "./BankCard.vue?vue&type=script&lang=js&"
import style0 from "./BankCard.vue?vue&type=style&index=0&id=c45e05ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45e05ba",
  null
  
)

export default component.exports